/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TeRitoRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  @service
  toaster;

  async model() {
    let connection = undefined;
    let querySucceeded = false;
    try {
      let connections = await this.store.query('te-rito/connection', {
        schoolId: this.get('session.school.id'),
      });
      querySucceeded = true;
      connection = connections.at(0) ?? undefined;
    } catch {
      this.toaster.error('Error loading connection!');
    }
    if (querySucceeded && !connection) {
      try {
        connection = await this.store.createRecord('te-rito/connection', {
          localId: this.get('session.jurisdictionalId'),
          schoolId: this.get('session.school.id'),
          syncEnabled: false,
        });
        await connection.save();
      } catch {
        this.toaster.error('Error creating connection!');
        connection = undefined;
      }
    }
    return hash({
      connection,
    });
  }
}
